import api from '@/lib/services/general.service'
import { TIMELINE_STATUS_PATH, membershipMap, membershipStatus } from '@/lib/ongoingMembership'

// The inbox's Ongoing-membership map (Pouria, 2026-09-02: the mailbox row's dot is an
// Ongoing-status dot). One fetch per landed listing page — the Inbox view dispatches `fetch` with
// the ids it is showing whenever they change — and the rows read the answer through `statusOf`.
// Deliberately its own small module rather than a limb of the timeline or ongoing modules: the map
// decorates the mailbox, and neither of those stores should re-fetch because a dot might.
export const state = {
  // lowercased timelineId → the ongoing's ladder status (see lib/ongoingMembership.js).
  map: {},
}

export const getters = {
  map: (s) => s.map,
  // The row's lookup: this thread's ongoing status, or null (no confirmed membership, no dot).
  statusOf: (s) => (timelineId) => membershipStatus(s.map, timelineId),
}

export const actions = {
  // The page's threads → the map. Best-effort by design: a failed read commits the EMPTY map — no
  // dots — rather than leaving a previous page's answer on rows it never described. Guests included
  // (the BFF runs them under a derived guest id like every other ongoing read).
  async fetch({ commit }, timelineIds) {
    const ids = (Array.isArray(timelineIds) ? timelineIds : []).filter(Boolean)
    if (!ids.length) {
      commit('SET_MAP', {})
      return {}
    }
    try {
      const res = await api.insertWithPath('ongoing', TIMELINE_STATUS_PATH, { timelineIds: ids })
      const map = membershipMap(res?.data)
      commit('SET_MAP', map)
      return map
    } catch {
      commit('SET_MAP', {})
      return {}
    }
  },
}

export const mutations = {
  SET_MAP(s, map) {
    s.map = map || {}
  },
}
